(function () {
  'use strict';

  angular
      .module('tfc.retailer.Brand')
      .factory('BrandReports', BrandReports);

  // @ngInject
  function BrandReports($q, $location, CookieJar, GaUtil, Api, Auth, BRAND_URL) {

    return {
      selectedBrandKey : selectedBrandKey,
      findBrandNames : findBrandNames,
      findUserBrandNames : findUserBrandNames,
      findFocusHierarchies : findFocusHierarchies,
      findAffinityHierarchies : findAffinityHierarchies,
      findConsistencyHierarchies: findConsistencyHierarchies,
      getBrandAffinity : getBrandAffinity,
      getPricePointData : getPricePointData,
      getPurchaseBrandItemCount : getPurchaseBrandItemCount,
      findConsistencySizeAdvices : findConsistencySizeAdvices,
      getReturnsPerformanceSummary : getReturnsPerformanceSummary,
      getReturnsPerformance : getReturnsPerformance,
      getReturnsPerformanceInsufficientDataStylesCount : getReturnsPerformanceInsufficientDataStylesCount,
      getConsistencyInsufficientDataStylesCount:getConsistencyInsufficientDataStylesCount,
      getReturnsPerformanceFilters: getReturnsPerformanceFilters,
      getReturnsPerformanceBySizeSummary :getReturnsPerformanceBySizeSummary,
      getReturnsPerformanceBySizeHierarchies : getReturnsPerformanceBySizeHierarchies,
      filterBrandCategories: filterBrandCategories,
      getBrandAffinityFilters:getBrandAffinityFilters,
      sendGAEventOnEnter:sendGAEventOnEnter,
      getConsistencyFilters : getConsistencyFilters,
      getDashboardAggregationLogDetails: getDashboardAggregationLogDetails,
      getConsumerSamplingSummary: getConsumerSamplingSummary,
      getConsumerSamplingGenderDetails: getConsumerSamplingGenderDetails,
      getConsumerSamplingAgeRangeDetails:getConsumerSamplingAgeRangeDetails
    };

    function selectedBrandKey(brandKey) {
      //TODO CookieJar should decode and encode for get & set cookie values respectively
      var promise, selectedBrandFromCookie = decodeURIComponent(CookieJar.get('tfc-insight-selected-brand'));
      promise = findUserBrandNames().then(function (brands) {
        var selectedBrand = brandKey || selectedBrandFromCookie;
        if((_.isArray(brands) && brands.length) && !_.find(brands, ['key', selectedBrand])){
          selectedBrand = _.minBy(brands, 'name').key;
          $location.search('brandKey', selectedBrand);
        } else if(_.isArray(brands) && brands.length===0){
          return $q.reject("Site.Error.LackPrivilege");
        }
        CookieJar.set({name : 'tfc-insight-selected-brand',value : encodeURIComponent(_.toString(selectedBrand))});
        return $q.when(selectedBrand);
      });
      return promise;
    }

    function findBrandNames() {
      return Api.get('/brand/names', { cache : true })
          .then(_.property('data'));
    }

    function findUserBrandNames() {
      return Api.get('/brand/userbrands', { cache : true })
          .then(_.property('data'));
    }

    function findFocusHierarchies(brandKey, transaction) {
      return Api.get('/brand/report/affinity/hierarchies/focus', {
        params : { brandKey : brandKey, transaction: transaction }
      }).then(_.property('data'));
    }

    function findAffinityHierarchies(brandKey, focusDepartment, focusCategory, transaction) {
      return Api.get('/brand/report/affinity/hierarchies/affinity', {
        params : { brandKey : brandKey, department : focusDepartment, category: focusCategory, transaction: transaction}
      }).then(_.property('data'));
    }

    function findConsistencyHierarchies(brandKey, region, transaction) {
      return Api.get('/brand/report/consistency/hierarchies', {
        cache : true,
        params : { brandKey : brandKey, region: region, transaction: transaction }
      }).then(_.property('data'));
    }

    function findConsistencySizeAdvices(brandKey, department, category, region, transaction) {
      if(department && category){
        return Api.get('/brand/report/consistency/sizeAdvice', {
          cache : true,
          params : { brandKey : brandKey ,department : department, category: category, region: region, transaction: transaction }
        }).then(_.property('data'));
      }
    }

    function getConsistencyInsufficientDataStylesCount(brandKey, department, category, region, transaction) {
      return Api.get('/brand/report/consistency/insufficientDataStylesCount', {
        cache : true,
        params : { brandKey : brandKey ,department : department, category: category, region: region, transaction: transaction }
      }).then(_.property('data'));
    }

    function getConsistencyFilters(brandKey) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/consistency/filters', {cache : true}).then(_.property('data'));
    }

    function getBrandAffinity(brandKey, timeFrame, focusDepartment, focusCategory, affinityDepartment, affinityCategory, region, transaction, limit) {
      return Api.get('/brand/report/affinity/sales', {
        params : { brandKey : brandKey, timeFrame : timeFrame, focusDepartment : focusDepartment, focusCategory: focusCategory,
            affinityDepartment : affinityDepartment, affinityCategory: affinityCategory, region: region, transaction: transaction, limit : limit}
      }).then(_.property('data'));
    }

    function getPricePointData(brandKey, timeFrame, focusDepartment, focusCategory, affinityDepartment, affinityCategory, region, transaction) {
      return Api.get('/brand/report/affinity/price', {
        params : { brandKey : brandKey, timeFrame : timeFrame, focusDepartment : focusDepartment, focusCategory: focusCategory,
           affinityDepartment : affinityDepartment, affinityCategory: affinityCategory, region: region, transaction: transaction}
      }).then(_.property('data'));
    }

    function getPurchaseBrandItemCount(brandKey, timeFrame, focusDepartment, focusCategory, affinityDepartment, affinityCategory, region, transaction) {
      return Api.get('/brand/report/affinity/itemCount', {
        params : { brandKey : brandKey, timeFrame : timeFrame, focusDepartment : focusDepartment, focusCategory: focusCategory,
          affinityDepartment : affinityDepartment, affinityCategory: affinityCategory, region: region, transaction: transaction}
      }).then(_.property('data'));
    }

    function getReturnsPerformanceSummary(brandKey, transaction, region){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/performance/returns/summary', {
        cache : true,
        params: { transaction : transaction, region : region}
      }).then(_.property('data'));
    }

    function getReturnsPerformance(brandKey, department, category, transaction, region){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/performance/returns', {
        cache : true,
        params : { department : department, category: category, transaction : transaction, region : region }
      }).then(_.property('data'));
    }

    function getReturnsPerformanceFilters(brandKey) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/performance/returns/filters', {cache : true}).then(_.property('data'));
    }

    function getReturnsPerformanceInsufficientDataStylesCount(brandKey, department, category, region, transaction) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/performance/insufficientDataStylesCount', {
        params : { department : department, category: category, region: region, transaction: transaction}
      }).then(_.property('data'));
    }

    function getReturnsPerformanceBySizeSummary(brandKey, department, category, localeCode, sizeType) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/performance/returnsBySize/summary', {
        params : { department : department, category: category,localeCode: localeCode,sizeType: sizeType }
      }).then(_.property('data'));
    }

    function getReturnsPerformanceBySizeHierarchies(brandKey){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) + '/report/performance/returnsBySize/hierarchies').then(_.property('data'));
    }

    function filterBrandCategories(hierarchyObj) {
      return hierarchyObj.department !== "Baby" && hierarchyObj.department !== "Girls" && hierarchyObj.department !== "Boys" && hierarchyObj.department !== "UnisexKids" && hierarchyObj.category;
    }

    function getBrandAffinityFilters(brandKey) {
      return Api.get('/brand/report/affinity/filters',{ params: { brandKey : brandKey } } ).then(_.property('data'));
    }

    function sendGAEventOnEnter(selectedBrandKey, eventAction, eventLabel){
        GaUtil.sendGaEvent(selectedBrandKey, eventAction, eventLabel);
    }

    // TODO: Deprecated Method, replace calls with ActivityRegionFactor methods
    function getRegionFilter(filters, selectedActivity){
      var regions = [];
      if(_.find(filters,'transaction')){
        regions = _(filters).filter({transaction: selectedActivity && selectedActivity.transaction}).map('region').flatten().value();
      } else {
        regions = (filters.length && filters[0].region) ? _(filters[0].region).value() : [];
      }
      if(regions.length > 2){
        return regions;
      } else {
        return [];
      }
    }

    function getAggregationLogDetails() {
      var user = Auth.getUser();
      if(user && _.includes(user.privileges, 'viewAggregationLog')){
        return Api.get('/log/aggregations/latest', {cache : true}).then(_.property('data'));
      }
    }

    function getDashboardAggregationLogDetails(report) {
      // making a promise so as to consider the else case if user don't have privilege
      return $q.when(getAggregationLogDetails()).then(function(data){
        return _.find(data, {report: report});
      });
    }

    function getConsumerSamplingSummary(brandKey){
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) +'/consumer/sampling/summary').then(_.property('data'));
    }

    function getConsumerSamplingGenderDetails(brandKey) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) +'/consumer/sampling/gender').then(_.property('data'));
    }

    function getConsumerSamplingAgeRangeDetails(brandKey) {
      return Api.get(Api.withEncodedPath(BRAND_URL, brandKey) +'/consumer/sampling/ageRange').then(_.property('data'));
    }

  }

})();
